/**
 * COPPER ROAD DESIGN TOKENS
 * Matches the approved end-user mockup exactly
 * Fonts: Playfair Display (headings) + DM Sans (body)
 */

// Inject Google Fonts
if (typeof document !== 'undefined') {
  const fontLink = document.createElement('link');
  fontLink.rel = 'stylesheet';
  fontLink.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,900;1,400&family=DM+Sans:wght@300;400;500;600&display=swap';
  if (!document.querySelector("link[href*='Playfair']")) document.head.appendChild(fontLink);
}

export const T = {
  copper: "#B87333", copperLight: "#D4895A", copperDark: "#7A4A1E",
  cream: "#F0EDE8", creamDark: "#DDD8D0",
  ink: "#0F1A1F", inkMid: "#1C3040", bark: "#2A4A5C",
  smoke: "#7A8F96", gold: "#C8985A",
  success: "#4A7C59", successBg: "#E8F5ED",
  danger: "#C0392B", dangerBg: "#FDECEA",
  info: "#1C6EA4", infoBg: "#E8F1F8",
};

export const fonts = {
  heading: "'Playfair Display', serif",
  body: "'DM Sans', sans-serif",
};
